import { render, staticRenderFns } from "./ImportantDateOverview.vue?vue&type=template&id=3b2b7974&scoped=true&"
import script from "./ImportantDateOverview.vue?vue&type=script&lang=js&"
export * from "./ImportantDateOverview.vue?vue&type=script&lang=js&"
import style0 from "./ImportantDateOverview.vue?vue&type=style&index=0&id=3b2b7974&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2b7974",
  null
  
)

export default component.exports